module.exports = __webpack_public_path__ + "img/[呲牙].3b5d3537.svg";